<template>
  <PropertyOnboardingStep
    title="How can tenants view your property?"
    :is-next-button-disabled="!formRef?.isFormValid"
    :submit="submit"
  >
    <TourTypesForm ref="formRef" />
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { TourTypesForm } from '@tallo/investor/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const formRef = ref<InstanceType<typeof TourTypesForm>>();

async function submit() {
  await formRef.value?.save();
}
</script>

<style scoped lang="scss"></style>
